<template>
  <span
    v-if="
      job.type?.name === 'hire_delivery' || job.type?.name === 'hire_collection'
    "
  >
    {{ job.jobable?.vehicle?.start_date | date }}
    <span v-if="job.jobable?.vehicle?.start_date"
      ><span v-if="job.jobable?.vehicle?.end_date"
        >to {{ job.jobable?.vehicle?.end_date | date }}</span
      ><span v-else>to Ongoing</span></span
    >
  </span>
</template>
<script>
export default {
  props: {
    job: {
      type: Object,
      required: true
    }
  }
};
</script>
